import React from 'react'

export default function IconUpgradeChevrons({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            className={className}
            style={style}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.29279 16.2152C4.10532 16.0277 4 15.7734 4 15.5082C4 15.243 4.10532 14.9887 4.29279 14.8012L9.29279 9.80121C9.48031 9.61374 9.73462 9.50842 9.99979 9.50842C10.265 9.50842 10.5193 9.61374 10.7068 9.80121L15.7068 14.8012C15.8889 14.9898 15.9897 15.2424 15.9875 15.5046C15.9852 15.7668 15.88 16.0176 15.6946 16.203C15.5092 16.3884 15.2584 16.4936 14.9962 16.4959C14.734 16.4982 14.4814 16.3974 14.2928 16.2152L9.99979 11.9222L5.70679 16.2152C5.51926 16.4027 5.26495 16.508 4.99979 16.508C4.73462 16.508 4.48031 16.4027 4.29279 16.2152ZM4.29279 10.2152C4.10532 10.0277 4 9.77337 4 9.50821C4 9.24304 4.10532 8.98874 4.29279 8.80121L9.29279 3.80121C9.48031 3.61374 9.73462 3.50842 9.99979 3.50842C10.265 3.50842 10.5193 3.61374 10.7068 3.80121L15.7068 8.80121C15.8889 8.98981 15.9897 9.24241 15.9875 9.50461C15.9852 9.76681 15.88 10.0176 15.6946 10.203C15.5092 10.3884 15.2584 10.4936 14.9962 10.4959C14.734 10.4982 14.4814 10.3974 14.2928 10.2152L9.99979 5.92221L5.70679 10.2152C5.51926 10.4027 5.26495 10.508 4.99979 10.508C4.73462 10.508 4.48031 10.4027 4.29279 10.2152Z'
                fill={fillColor}
            />
        </svg>
    )
}
